import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'

type WrapperProps = {
  width?: string
}

export const Wrapper = styled.div<WrapperProps>`
  ${({ theme, width }) => `
    width: ${width};
    padding-bottom: ${theme.space.mobile.base};
  `}

  ${({ theme }) => media.sm`
    border-right: 2px solid ${theme.color.greyLight};
  `}
`
